<div class="messages">
  <short-message *ngFor="let mess of messages" [message]="mess" [editable]="editable" (removeMessage)="onRemoveMessage(mess, $event)"></short-message>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer-home/recent-messages/recent-messages.component.html